import React, { useState, useEffect } from 'react';
import { object, func } from 'prop-types';

import { CloneObject, GetTipoDato } from '../../../utils/helpers';
import { isEmptyString } from '../../../utils/validator';
import { useForm } from '@laramie/ui';


import { useFormErrors } from '../../hooks/useFormErrors';
import { FormError, InputCustom, FormLabel, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ProcedimientoParametroModal = (props) => {

  const [state, setState] = useState({
    listParametros: [],
    listValores: []
  });

  const mount = () => {

    let valores = {};
    props.data.listParametros.forEach(parametro => {
      const emisionProcedimientoParametro = props.data.listValores.find(f => f.idProcedimientoParametro === parametro.id);
      valores[parametro.codigo] = !isEmptyString(emisionProcedimientoParametro.valor) ? emisionProcedimientoParametro.valor : "0";
    });

    setState({
      listParametros: props.data.listParametros,
      listValores: props.data.listValores
    });
    formSet(valores);
  }
  useEffect(mount, [props.data]);

  const [ formValues, formHandle, , formSet ] = useForm({});

  const { errorOf, validate } = useFormErrors(getErrors);

  function getErrors() {

    const errors = {};

    state.listParametros.forEach(parametro => {
      if (isEmptyString(formValues[parametro.codigo])) errors[parametro.codigo] = VALIDATION_MESSAGE.REQUIRED_SHORT;
    });

    return errors;
  }

  //handles
  const handleClickAceptar = () => {
      if (!validate()) return;

      let rows = [];
      for (let i=0; i< state.listParametros.length; i++) {
        const parametro = state.listParametros[i];
        const formValue = formValues[parametro.codigo];

        const emisionProcedimientoParametro = state.listValores.find(f => f.idProcedimientoParametro === parametro.id);
        if (formValue !== emisionProcedimientoParametro.valor) {
          let row = CloneObject(emisionProcedimientoParametro);
          row.valor = formValue;
          rows.push(row);
        }
      }

      props.onConfirm(rows);
  };


  return (
    <>

    <Modal
      size="md"
      title="Valores de parámetros"
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
                {state.listParametros.map((parametro, index) => 
                  <div key={parametro.codigo} className="mb-3 col-4">
                      <FormLabel htmlFor={parametro.codigo} required>{parametro.nombre}</FormLabel>
                      <InputCustom
                          name={parametro.codigo}
                          type={ parametro.tipoDato }
                          placeholder={`Ingrese un valor de tipo ${GetTipoDato(parametro.tipoDato)}`}
                          className="form-control"
                          value={ formValues[parametro.codigo] }
                          onChange={ formHandle }
                          serialize={true}
                          invalid={!!errorOf(parametro.codigo)}
                      />
                      <FormError message={errorOf(parametro.codigo)} />
                  </div>
                )}

            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

ProcedimientoParametroModal.propTypes = {
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

export default ProcedimientoParametroModal;